import { type DecoratedGameParticipant, getName } from '@terros/common'

export const getGameParticipantName = (participant: DecoratedGameParticipant): string => {
  if (participant.type === 'user') {
    return getName(participant)
  }
  return participant.name
}
